import './nav.css'
import { ChartNoAxesColumnIncreasing, Settings } from 'lucide-react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faGear } from "@fortawesome/free-solid-svg-icons";
import '../App.css'
import { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import MessageModal from '../Pages/messageModal';
import { useDispatch, useSelector } from 'react-redux';
import { changeBanner, changeEnergy, changeGold, checkDuplicateLogins, checkIframBtn, checkJackpot, checkSuperJackpot } from '../store';
import { changeNum, changeUnits, handleVibration } from '../Pages/common/function';
import axios from 'axios';
import { useTranslation } from "react-i18next";

import useWindowSize from '../hook/useWindowSize'

function Header() {
    const { t } = useTranslation();

    const gold = useSelector((state) => { return state.gold.value })
    const myData = useSelector((state) => { return state.myData })
    const JWT = useSelector((state) => { return state.JWT.value })
    const haptic = useSelector((state) => { return state.haptic.value })

    let navigate = useNavigate()
    let dispatch = useDispatch()
    let location = useLocation();

    const { Rwidth, Rheight } = useWindowSize();
    const [adsHeightState, setAdsHeightState] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            if (location.pathname == "/") {
                const windowHeight = window.innerHeight;

                if (windowHeight <= 580) {
                    setAdsHeightState(1)
                } else if (windowHeight <= 650) {
                    setAdsHeightState(2)
                } else if (windowHeight <= 720) {
                    setAdsHeightState(3)
                } else {
                    setAdsHeightState(0)
                }
            } else {
                setAdsHeightState(0)
            }
        };

        handleResize();

    }, [Rheight]);

    useEffect(() => {
        let jackpotIntervalId;

        if (JWT?.length > 0) {
            fetchJackpotData(); // 초기 호출
            fetchSuperJackpotData()

            // 10초마다 jackpot 요청
            jackpotIntervalId = setInterval(() => {
                fetchJackpotData();
                fetchSuperJackpotData()
            }, 10 * 1000);
        }

        // cleanup
        return () => {
            if (jackpotIntervalId) clearInterval(jackpotIntervalId);
        };
    }, [JWT]);

    // 잭팟 시간 및 확율 확인
    const fetchJackpotData = async () => {
        await axios.get(process.env.REACT_APP_API + `/api/jackpot/slot`, {
            headers: {
                Authorization: `Bearer ${JWT}`,
            }
        }).then((response) => {
            let tmp = response.data
            // console.log(tmp.data)
            if (tmp?.code == 1000) {
                dispatch(checkJackpot(tmp?.data ?? []))
            } else {
                dispatch(checkJackpot([]))
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const fetchSuperJackpotData = async () => {
        await axios.get(process.env.REACT_APP_API + `/api/super-jackpot/slot`, {
            headers: {
                Authorization: `Bearer ${JWT}`,
            }
        }).then((response) => {
            let tmp = response.data
            // console.log(tmp.data)
            if (tmp?.code == 1000) {
                dispatch(checkSuperJackpot(tmp?.data ?? {}))
            } else {
                dispatch(checkSuperJackpot({}))
            }
        }).catch((error) => {
            if (error?.status === 999) {
                dispatch(checkDuplicateLogins(true))
            }
            else {
                console.log(error)
            }
        })
    };

    const onClickBtn = (e) => {
        if (haptic) handleVibration(1);
        navigate(e)
    }


    return (
        <div className='header'>
            {
                adsHeightState === 2 || adsHeightState === 0
                    ?
                    <div className='header1'>
                        <div className='header1-backgroud'>
                            <img src='/img/default_cat_short.png' style={{ pointerEvents: "none" }} />
                        </div>
                        <div>{myData?.user_name ?? ""} ({myData?.id ?? ""})</div>
                    </div>
                    :
                    ""
            }
            <div className='header2'>
                {/* <div className='header2-1'>
                    <div className='header2-1-2' style={{ paddingTop: "2px" }}>
                        <div className='header2-1-2-2 fontNumber' style={{ width: "50%" }}>
                            <img src='/newImg/icon_main_diamond.png' style={{ pointerEvents: "none", width: "26px" }} />
                            <div style={{ display: 'flex', alignItems: "center" }}>
                                <span>{changeUnits(gold)}</span>
                            </div>
                        </div>
                        <div className='header2-1-2-2 fontNumber' style={{ width: "50%" }}>
                            <img src='/newImg/icon_main_jackpot(new).png' style={{ pointerEvents: "none", width: "24px" }} />
                            <div style={{ display: 'flex', alignItems: "center" }}>
                                <span>{changeUnits(jackpotSum)}</span>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className='header2-2'>
                    <div className='header2-1-2' style={{ paddingTop: "2px" }}>
                        <div className='header2-1-2-2 fontNumber' style={{ width: "50%", paddingLeft: '7px' }}>
                            <img src='/newImg/icon_main_diamond.png' style={{ pointerEvents: "none", width: "26px" }} />
                            <div style={{ display: 'flex', alignItems: "center" }}>
                                <span>{changeNum(gold)}</span>
                            </div>
                        </div>
                        <div style={{ padding: "5px 7px", borderLeft: "1px solid #43433b" }} onClick={() => onClickBtn('/setting')}>
                            <FontAwesomeIcon icon={faGear} fontSize={16} />
                        </div>
                    </div>
                </div>
                <div className='header2-1'>
                    <div className='header2-2-1' onClick={() => navigate('/memories')}>
                        <img src='/newImg/icon_main_heart.png' style={{ pointerEvents: "none", width: "32px" }} />
                        <div>{t('header_0')}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;